document.addEventListener('alpine:init', () => {
	Alpine.data('sc_accordion', (cfg) => ({
		openIds: [],
		single: cfg.single !== false,

		init() {
			if (cfg.defaultOpen) {
				this.openIds = [cfg.defaultOpen];
			}
		},

		// Called by each child Collapse via x-init. expanded reflects the child's
		// CollapseProps.Expanded; Accordion's DefaultOpen wins when both are set.
		register(id, expanded) {
			if (!expanded) return;
			if (this.openIds.length === 0) {
				this.openIds.push(id);
				return;
			}
			if (!this.openIds.includes(id)) {
				console.warn(
					`[sc_accordion] Collapse "${id}" set Expanded:true but Accordion DefaultOpen took precedence.`,
				);
			}
		},

		isOpen(id) {
			return this.openIds.includes(id);
		},

		toggle(id) {
			const i = this.openIds.indexOf(id);
			if (i >= 0) {
				this.openIds.splice(i, 1);
				return;
			}
			if (this.single) {
				this.openIds = [id];
			} else {
				this.openIds.push(id);
			}
		},
	}));
});
